import ChatMentionTarget from '../models/ChatMentionTarget';
import { MENTION_EXP } from './ChatMentionExpression';

export type ChatContentElement = string | ChatMentionTarget;

export default function parseChatContent(source: string, targets: Array<ChatMentionTarget>): Array<ChatContentElement> {
  const mentionExp = new RegExp(MENTION_EXP, 'gu');
  const elements = [];
  let textStart = 0;

  for (; ;) {
    const match = mentionExp.exec(source);
    if (!match) break;

    const name = match[1];
    const target = targets.find(t => t.name === name);
    if (!target) continue; // eslint-disable-line no-continue

    const matchStart = mentionExp.lastIndex - match[0].length;
    if (matchStart > textStart) {
      elements.push(source.substring(textStart, matchStart));
    }
    textStart = mentionExp.lastIndex;
    elements.push(target);
  }

  if (textStart < source.length) {
    elements.push(source.substring(textStart));
  }
  return elements;
}